export const getQueryString = (key: string): string | null => new URLSearchParams(window.location.search).get(key);
